import { core_v1_DataSource_FieldUtils } from '@antimatterhq/asl-api-ts-v1';
import { getFieldSchemaValues, setFieldSchemaValues } from './field';
import { TemporaryFieldSchemaValues } from '@/zod/schemas/dataSource/Common';
import { filterNulls } from '@/utils/filterNulls';

export const getTemporaryFields = (
  utils?: core_v1_DataSource_FieldUtils | null,
): TemporaryFieldSchemaValues => {
  return {
    temporaryFields: getFieldSchemaValues(
      filterNulls(utils?.temporaryFields || []),
    ),
  };
};

export const setTemporaryFields = (
  temporaryFields: TemporaryFieldSchemaValues,
): core_v1_DataSource_FieldUtils['temporaryFields'] => {
  return setFieldSchemaValues(temporaryFields.temporaryFields);
};
